import { supabase } from "@/integrations/supabase/client";

export async function logSimulationActivity(
  userId: string,
  agentName: string,
  score: number,
  evaluationId: string
) {
  await supabase
    .from('user_activity_log')
    .insert({
      user_id: userId,
      activity_type: 'simulation_completed',
      title: `Completed ${agentName}`,
      description: `Scored ${score}/100`,
      score,
      metadata: { evaluation_id: evaluationId, agent_name: agentName },
    });
}

export async function logCoachingActivity(
  userId: string,
  templateName: string,
  readinessScore: number | undefined,
  sessionId: string
) {
  await supabase
    .from('user_activity_log')
    .insert({
      user_id: userId,
      activity_type: 'coaching_completed',
      title: `Completed coaching: ${templateName}`,
      description: readinessScore ? `Readiness: ${readinessScore}%` : 'Session completed',
      score: readinessScore,
      metadata: { session_id: sessionId, template_name: templateName },
    });
}

export async function logStreakMilestone(
  userId: string,
  streakDays: number
) {
  await supabase
    .from('user_activity_log')
    .insert({
      user_id: userId,
      activity_type: 'streak_milestone',
      title: `${streakDays}-day streak! 🔥`,
      description: `Maintained a ${streakDays}-day learning streak`,
      metadata: { streak_days: streakDays },
    });
}

export async function logGoalReached(
  userId: string,
  agentName: string,
  score: number
) {
  await supabase
    .from('user_activity_log')
    .insert({
      user_id: userId,
      activity_type: 'goal_reached',
      title: `Goal Reached! 🎯`,
      description: `Achieved goal score on ${agentName}`,
      score,
      metadata: { agent_name: agentName },
    });
}

export async function logQuizCompleted(
  userId: string,
  quizTitle: string,
  score: number,
  totalQuestions: number,
  passed: boolean
) {
  await supabase
    .from('user_activity_log')
    .insert({
      user_id: userId,
      activity_type: 'quiz_completed',
      title: passed ? `Quiz Passed: ${quizTitle}` : `Quiz Attempted: ${quizTitle}`,
      description: `Scored ${score}/${totalQuestions} (${Math.round((score / totalQuestions) * 100)}%)`,
      score: Math.round((score / totalQuestions) * 100),
      metadata: { quiz_title: quizTitle, correct: score, total: totalQuestions, passed },
    });
}

export async function logPathwayCompleted(
  userId: string,
  pathwayTitle: string,
  pathwayId: string
) {
  await supabase
    .from('user_activity_log')
    .insert({
      user_id: userId,
      activity_type: 'pathway_completed',
      title: `Pathway Complete: ${pathwayTitle}`,
      description: 'Completed all modules in this learning pathway',
      metadata: { pathway_id: pathwayId, pathway_title: pathwayTitle },
    });
}

export async function logContentGenerated(
  userId: string,
  contentType: string,
  title: string
) {
  await supabase
    .from('user_activity_log')
    .insert({
      user_id: userId,
      activity_type: 'content_generated',
      title: `Created ${contentType}: ${title}`,
      description: `Generated ${contentType} in Content Studio`,
      metadata: { content_type: contentType, title },
    });
}

export async function logAssessmentCompleted(
  userId: string,
  assessmentName: string,
  score: number
) {
  await supabase
    .from('user_activity_log')
    .insert({
      user_id: userId,
      activity_type: 'assessment_completed',
      title: `Assessment: ${assessmentName}`,
      description: `Completed physical assessment with score ${score}/100`,
      score,
      metadata: { assessment_name: assessmentName },
    });
}
